<template>
<v-card class='elevation-10' >
  <v-card-title class='subtitle-1 overline' >
    {{title}}
  </v-card-title>
  <v-divider></v-divider>
  <slot></slot>
  <v-card-text class='grey lighten-4'>
  <v-layout>
    <v-flex xs6 >
      <v-card v-if='left' class='mt-2' >
        <v-btn fab absolute top right small color='info' v-text='left.length' />
        <v-list class='pa-0' v-if='left.length > 0' dense >
          <template v-for='(item, index) in left' >
            <generic-list-item :key='item.id' with-id
              v-model='left[index]'
              :item-title='itemTitle'
              :item-sub-title='itemSubTitle' >
              <!-- <v-list-tile-actiion slot='action' >
                <v-checkbox v-model='selected' :value='item.id' />
              </v-list-tile-actiion> -->
            </generic-list-item>
            <v-divider :key='`div-${item.id}`' />
          </template>
        </v-list>
        <v-subheader class='pa-3' v-else >No items to merge</v-subheader>
      </v-card>
    </v-flex>
    <v-flex xs6 >
      <v-card v-if='right' class='mt-2' >
        <v-btn fab absolute top right small color='info' v-text='right.length' />
        <v-list class='pa-0' v-if='right.length > 0' dense >
          <template v-for='(item, index) in right' >
            <generic-list-item :key='item.id' with-id
              v-model='right[index]'
              :item-title='itemTitle'
              :item-sub-title='itemSubTitle' >
              <v-list-tile-action slot='action' >
                <v-checkbox v-model='selected' :value='item.id' />
              </v-list-tile-action>
            </generic-list-item>
            <v-divider :key="`div-${item.id}`" />
          </template>
        </v-list>
        <v-subheader class='pa-3' v-else >No items to merge</v-subheader>
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn
            :loading='loading'
            :disabled='selected.length === 0'
            color='primary'
            @click='$emit("transfer", selected)' >
            <v-icon >keyboard_backspace</v-icon>
            Transfer {{selected.length}} items
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
  </v-card-text>
</v-card>
</template>
<script>
import GenericListItem from '@/components/listitems/GenericListItem'

export default {
  name: 'ArrayMergePreview',
  components: {
    GenericListItem
  },
  props: {
    value: { type: Array, default: () => { return [] } },
    title: { type: String, default: 'Pick one' },
    itemTitle: { type: String, required: false },
    itemSubTitle: { type: String, required: false },
    loading: { type: Boolean, default: false },
    left: { required: true },
    right: { required: true }
  },
  data () {
    return {
      selected: []
    }
  },
  methods: {
    transfer (req, data) {
      req.data = data
      this.$request('get', req)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ArrayMergePreview.vue?5a854791